module.exports = __webpack_public_path__ + "static/media/NodeLoads.a8f10e7a.svg";